import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageSection } from "@/components/AppLayout.jsx";
import { usePublicCopy } from "@/i18n/karatePublicI18n.js";
import * as r0 from "@/api/karateR0InstructorsApi.js";

export function PublicInstructorDetailR0Page() {
  const { id } = useParams();
  const { copy } = usePublicCopy();
  const [instructor, setInstructor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    async function load() {
      setLoading(true);
      const result = await r0.fetchPublicInstructor(id);
      if (!active) return;
      setLoading(false);
      if (!result.ok) {
        setError(result.body?.error ?? "Instructeur introuvable.");
        return;
      }
      setInstructor(result.body.instructor);
    }
    load();
    return () => {
      active = false;
    };
  }, [id]);

  return (
    <PageSection title={copy.directory?.instructorDetailTitle ?? "Fiche instructeur"} testId="page-instructor-detail">
      <p>
        <Link to="/instructeurs" data-testid="instructor-detail-back">
          ← {copy.directory?.backToInstructors ?? "Retour aux instructeurs"}
        </Link>
      </p>

      {loading ? <p>{copy.directory?.loading ?? "Chargement…"}</p> : null}
      {error ? (
        <p className="form-error" role="alert" data-testid="instructor-detail-error">
          {error}
        </p>
      ) : null}

      {instructor ? (
        <article className="instructor-detail" data-testid="instructor-detail-card">
          {instructor.photoUrl ? (
            <img
              className="instructor-detail__photo"
              src={instructor.photoUrl}
              alt={`${instructor.firstName} ${instructor.lastName}`}
            />
          ) : (
            <div className="instructor-detail__photo instructor-detail__photo--placeholder" aria-hidden="true">
              {instructor.firstName?.[0]}
              {instructor.lastName?.[0]}
            </div>
          )}
          <div>
            <h2 data-testid="instructor-detail-name">
              {instructor.firstName} {instructor.lastName}
            </h2>
            {instructor.title ? (
              <p className="instructor-detail__title" data-testid="instructor-detail-title">
                {instructor.title}
              </p>
            ) : null}
            {instructor.dojo ? (
              <p data-testid="instructor-detail-dojo">
                <Link to={`/dojos/${instructor.dojo.id}`}>
                  {instructor.dojo.name} — {instructor.dojo.city}
                </Link>
              </p>
            ) : null}
            {instructor.yearsExperience != null ? (
              <p data-testid="instructor-detail-experience">
                {instructor.yearsExperience} année{instructor.yearsExperience > 1 ? "s" : ""} d&apos;expérience
              </p>
            ) : null}
            {instructor.specialties ? (
              <p data-testid="instructor-detail-specialties">
                <strong>{copy.directory?.specialtiesLabel ?? "Spécialités :"} </strong>
                {instructor.specialties}
              </p>
            ) : null}
            {instructor.biography ? (
              <p className="instructor-detail__bio" data-testid="instructor-detail-biography">
                {instructor.biography}
              </p>
            ) : null}
          </div>
        </article>
      ) : null}
    </PageSection>
  );
}
